import React from "react";
import { Container, Row, Col } from "shards-react";
import RebateProviders from "../components/invoicing/RebateProviders";

const RebatesView = props => {
  const { provider_id } = props.match.params;
  const { client_id } = props.match.params;

  return (
    <Container fluid className="main-content-container px-4">
      <Row>
        <Col className="p-2">
          <RebateProviders provider_id={provider_id} client_id={client_id} />
        </Col>
      </Row>
    </Container>
  );
};

export default RebatesView;
